import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Shower } from "@mui/icons-material";
import axiosRequest from "../../api/axios";
import SnackBarComponent from "../Helpers/SnackBarComponent";
import { CropLandscapeOutlined } from "@material-ui/icons";
import LinearProgress from "@mui/material/LinearProgress";
import CircularProgress from "@mui/material/CircularProgress";
import DownloadImg from "../../assests/download.svg";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { CSVLink } from "react-csv";
export default function REPHQLevelTable() {
  const [budget, setBudget] = useState(0);
  const [budgetId, setBudgetId] = useState(0);
  const [temp, settemp] = useState(0);
  const [rows, setrows] = useState([]);

  function sumArray(array) {
    let sum = 0;

    /*Go through each item in the array and execute this function which adds
  each item to sum 
  */
    array.forEach((item) => {
      sum += parseInt(item);
    });

    // console.log(sum, "SUMMM");
    return sum;
  }
  const api_headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+localStorage.getItem("Token")
  }
  // logic for increase/decrease_1
  const [loader, setLoader] = useState(false);
  const [unadjustedList, setunadjustedList] = useState({});
  const [addedList, setaddedList] = useState({});
  const [showErrorMsg, setshowErrorMsg] = useState(false);
  const [adjustedBrand, setadjustedBrand] = useState("");
  const [adjustedId, setadjustedId] = useState(0);
  const [errorMessage, seterrorMessage] = useState("");
  const [EnteredValue, setEnteredValue] = useState(0);
  const [brandWiseSum, setbrandWiseSum] = useState(0);
  const [totalBrandSum, settotalBrandSum] = useState({});
  const [adjustedtotalBrandSum, setadjustedTotalBrandSum] =
    useState(totalBrandSum);
  const [keysList, setkeysList] = useState([]);
  const [calculatedRci, setcalculatedRci] = useState("");
  const [comments, setcomments] = useState("");
  const [commentsColor, setcommentsColor] = useState("");
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const handleClose = () => {
    setOpensb(false);
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };

  // Api to get Total table data
  const gettabledata = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getbuheaddata/",
      method: "POST",
      data: {
        team: localStorage.getItem("teamcode"),
        year:localStorage.getItem('year'),
        quarter:localStorage.getItem('quarter'),
      },
    }).then((data) => {
      if (data.status === 200) {
      
        setLoader(false);
        setrows(data?.data?.data);
        setunadjustedList(data?.data?.m1unadj);
        setunadjustedList1(data?.data?.m2unadj);
        setunadjustedList2(data?.data?.m3unadj);
        setaddedList(data?.data?.m1unadj);
        setaddedList1(data?.data?.m2unadj);
        setaddedList2(data?.data?.m3unadj);
        settotalBrandSum(data?.data?.totm1unadj);
        settotalBrandSum1(data?.data?.totm2unadj);
        settotalBrandSum2(data?.data?.totm3unadj);
        handleSnackBar("Data Loaded Successfully", "success");

        setReasonSelected(false);
        // setadjustedTotalBrandSum(data?.data?.totm1unadj)
        // setadjustedTotalBrandSum1(data?.data?.totm2unadj)
        // setadjustedTotalBrandSum2(data?.data?.totm3unadj)
      } else {
        setLoader(false);
        setchangesSaved(false);

        handleSnackBar("No Data Found", "error");
      }
    });
  };

  // API to get filters data

  const [filtersData, setfiltersData] = React.useState({});
  const [BrandsListData, setBrandsListData] = React.useState([]);
  const [productsListData, setproductsListData] = React.useState([]);
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [selectedProduct, setselectedProduct] = React.useState([]);
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});

  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/getfilterrephqbudget/",
      method: "POST",
      headers: api_headers,
      data: {
        team: localStorage.getItem("teamcode"),
        year:localStorage.getItem('year'),
        quarter:localStorage.getItem('quarter'),
        repcode:localStorage.getItem('rephqcode'),
      },
    }).then((data) => {
      if (data.status === 200) {
        const temp_list = [];

        setfiltersData(data?.data?.data);
       
        for (let brand of data?.data?.data) {
          temp_list.push(brand["brandname"]);
        }
        setBrandsListData(temp_list);
      
        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
       
      }
    });
  };

  //Api to filter the metrics selected on the brand and product filter
  const [Quarter, setQuarter] = React.useState("");
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");

  const [AllBrandStatus, setAllBrandStatus] = React.useState([]);
  const [proceedSubmit, setproceedSubmit] = React.useState(false);
  const [filtersDataSum, setfiltersDataSum] = React.useState({});
  let sum_data = {
    adj_tot_u: 0,
    adj_tot_v: 0,
    adj_tot_u1: 0,
    adj_tot_v1: 0,
    adj_tot_u2: 0,
    adj_tot_v2: 0,
  };
  const getAllBrandsStatus = async () => {
    await axiosRequest({
      url: "bu_head_app/filtersresult",
      method: "POST",
      data: {
        brandname: "All",
        productname: ["All"],
        teamcode: localStorage.getItem("teamcode"),
        year:localStorage.getItem('year'),
        quarter:localStorage.getItem('quarter'),
      },
    }).then((data) => {
      if (data.status === 200) {
        setAllBrandStatus(data?.data?.data);
        setQuarter(data?.data?.data[0]["quarter"]);
      
        for (let item of AllBrandStatus) {
          if (item["status"] === "") {
           
            setdisabled(false);
          } else {
            setdisabled(true);
          
          }
        }
      } else {
        // console.log("ERROR IN ALL BRANDS STATUS");
      }
    });
  };

  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/getrephqdata/",
      method: "POST",
      headers: api_headers,
      data: {
        brandname: selectedBrand,
        productname: selectedProduct == "All" ? ["All"] : [selectedProduct],
        teamcode: localStorage.getItem("teamcode"),
        year:localStorage.getItem('year'),
        repcode:localStorage.getItem('rephqcode'),
        quarter:localStorage.getItem('quarter'),
      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        setunadjustedList(data?.data?.m1unadj);
        setunadjustedList1(data?.data?.m2unadj);
        setunadjustedList2(data?.data?.m3unadj);
        setaddedList(data?.data?.m1adj);
        setaddedList1(data?.data?.m2adj);
        setaddedList2(data?.data?.m3adj);
        settotalBrandSum(data?.data?.totm1unadj);
        settotalBrandSum1(data?.data?.totm2unadj);
        settotalBrandSum2(data?.data?.totm3unadj);
        handleSnackBar("Data Loaded Successfully", "success");
        let tot_data = data?.data?.data;
        let adj_tot_u = 0;
        let adj_tot_v = 0;
        let adj_tot_u1 = 0;
        let adj_tot_v1 = 0;
        let adj_tot_u2 = 0;
        let adj_tot_v2 = 0;

        
        for (let i = 0; i < tot_data?.length; i++) {
          adj_tot_u =
            adj_tot_u + parseFloat(tot_data[i]["m1_adjusted_budget_unit"] != null ? tot_data[i]["m1_adjusted_budget_unit"] : 0);
          adj_tot_v =
            adj_tot_v + parseFloat(tot_data[i]["m1_adjusted_budget_value"] != null ? tot_data[i]["m1_adjusted_budget_value"] : 0);
          adj_tot_u1 =
            adj_tot_u1 + parseFloat(tot_data[i]["m2_adjusted_budget_unit"] != null ? tot_data[i]["m2_adjusted_budget_unit"] : 0);
          adj_tot_v1 =
            adj_tot_v1 + parseFloat(tot_data[i]["m2_adjusted_budget_value"] != null ? tot_data[i]["m2_adjusted_budget_value"] : 0);
          adj_tot_u2 =
            adj_tot_u2 + parseFloat(tot_data[i]["m3_adjusted_budget_unit"] != null ? tot_data[i]["m3_adjusted_budget_unit"] : 0);
          adj_tot_v2 =
            adj_tot_v2 + parseFloat(tot_data[i]["m3_adjusted_budget_value"] != null ? tot_data[i]["m3_adjusted_budget_value"] : 0);
          // m2_qty_sum = m2_qty_sum+ parseFloat(tot_data[i]["m2_qty"])
          // m2_value_sum = m2_value_sum + parseFloat(tot_data[i]["m2_value"])
          // m2_nsp_sum = m2_nsp_sum + parseFloat(tot_data[i]["m2_nsp"])
          // m3_qty_sum = m3_qty_sum+ parseFloat(tot_data[i]["m3_qty"])
          // m3_value_sum = m3_value_sum + parseFloat(tot_data[i]["m3_value"])
          // m3_nsp_sum = m3_nsp_sum + parseFloat(tot_data[i]["m3_nsp"])
        }
        sum_data["adj_tot_u"] = parseFloat(adj_tot_u).toFixed(2);
        sum_data["adj_tot_v"] = parseFloat(adj_tot_v).toFixed(2);
        sum_data["adj_tot_u1"] = parseFloat(adj_tot_u1).toFixed(2);
        sum_data["adj_tot_v1"] = parseFloat(adj_tot_v1).toFixed(2);
        sum_data["adj_tot_u2"] = parseFloat(adj_tot_u2).toFixed(2);
        sum_data["adj_tot_v2"] = parseFloat(adj_tot_v2).toFixed(2);
        setfiltersDataSum(sum_data);
        //logic to display month name based on Quarter
        if (localStorage.getItem("quarter") == "Q1") {
          setMonth1("Jan");
          setMonth2("Feb");
          setMonth3("Mar");
        } else if (localStorage.getItem("quarter") == "Q2") {
          setMonth1("Apr");
          setMonth2("May");
          setMonth3("Jun");
        } else if (localStorage.getItem("quarter") == "Q3") {
          setMonth1("Jul");
          setMonth2("Aug");
          setMonth3("Sep");
        } else if (localStorage.getItem("quarter") == "Q4") {
          setMonth1("Oct");
          setMonth2("Nov");
          setMonth3("Dec");
        }
        // setfiltersOutputData()
       
      } else {
        setLoader(false);
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };

let colums_rbm = [
    { key: "id", label: "ID" },
    {
      key: "rbmcode",
      label: "RBM Code",
    },
    {
      key: "rbmname",
      label: "RBM Name",
    },
    {
      key: "abmcode",
      label: "ABM Code",
    },
    {
      key: "abmname",
      label: "ABM Name",
    },
    {
      key: "repcode",
      label: "REP Code",
    },
    {
      key: "repname",
      label: "REP Name",
    },
    {
      key: "brand",
      label: "Brand",
    },
    {
      key: "prodcode",
      label: "Product Code",
    },

    {
      key: "proddesc",
      label: "Product Desc",
    },
    {
      key: "m1_adjusted_budget_unit",
      label: `Bud.UN(${Month1})`,
    },
    {
      key: "m1_adjusted_budget_value",
      label: `Bud.Value(${Month1})`,
    },
    {
      key: "m2_adjusted_budget_unit",
      label: `Bud.UN(${Month2})`,
    },
    {
      key: "m2_adjusted_budget_value",
      label: `Bud.Val(${Month2})`,
    },

    {
      key: "m3_adjusted_budget_unit",
      label: `Bud.UN(${Month3})`,
    },
    {
      key: "m3_adjusted_budget_value",
      label: `Bud.Val(${Month3})`,
    },
  
  
   
];

  React.useEffect(() => {
    getfiltersdata();
    setQuarter( localStorage.getItem('quarter'))
   
    // getReasonsdata();
    // getAllBrandsStatus();
    // gettabledata();
  }, []);

  function between(x, min, max) {
    return x >= min && x <= max;
  }
  const [changesSaved, setchangesSaved] = useState(false);
  const [loaderSave, setloaderSave] = useState(false);
  const [loaderSubmit, setloaderSubmit] = useState(false);
  const handleSave = async () => {
    if (Object.entries(AllEditedIdsDict).length != 0) {
      Object.entries(AllEditedIdsDict).forEach(([key, value]) => {
        if (value === false) {
          setReasonSelected(false);
        } else {
          setReasonSelected(true);
        }
      });
    } else {
      setReasonSelected(true);
    }
    if (errorMessage != "" || errorMessage1 != "" || errorMessage2 != "") {
      handleSnackBar(
        "You cannot save until the adjustments are correct please check!",
        "error"
      );
    } else {
      if (ReasonSelected == true) {
        setloaderSave(true);
        await axiosRequest({
          url: "bu_head_app/updatebuheaddata/",
          method: "POST",
          data: {
            data: rows,
          },
        }).then((data) => {
          if (data.status === 200) {
            handleSnackBar("updated successfully", "success");
            gettabledata();
            setchangesSaved(true);
            setloaderSave(false);
            getAllBrandsStatus();
            Object.entries(AllEditedIdsDict).forEach(([key, value]) => {
              if (AllEditedIdsDict[key] === false) {
                AllEditedIdsDict[key] = true;
              }
            });
          } else {
            handleSnackBar("data not updated", "error");
            setloaderSave(false);
          }
        });
      } else {
        handleSnackBar(
          "Please select a Reason for all the adjustments",
          "warning"
        );
      }
    }
  };

  //APi for submit
  const [showModal, setshowModal] = useState(false);
  const [showStatusModal, setshowStatusModal] = useState(false);
  const handleCloseModal = () => {
    setshowModal(false);
  };
  const handleCloseStatusModal = () => {
    setshowStatusModal(false);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 510,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
  };
  const handleSubmit = async () => {
    for (let item of AllBrandStatus) {
      if (item["status"] == null) {
        setshowStatusModal(true);
      }
    }

    if (errorMessage != "" || errorMessage1 != "" || errorMessage2 != "") {
      handleSnackBar(
        "You cannot save until the adjustments are correct please check!",
        "error"
      );
    } else {
      if (changesSaved) {
        if (showStatusModal == false) {
          setloaderSubmit(true);
          await axiosRequest({
            url: "bu_head_app/approval",
            method: "POST",
            data: {
              email: localStorage.getItem("email"),
              teamcode: localStorage.getItem("teamcode"),
              year:localStorage.getItem('year'),
              quarter:localStorage.getItem('quarter'),
            },
          }).then((data) => {
            if (data.status === 200) {
              handleSnackBar("Submitted Successfully", "success");
              gettabledata();
              getAllBrandsStatus();
              setloaderSubmit(false);
            } else {
              handleSnackBar("Something", "error");
              setloaderSubmit(false);
            }
          });
        }
      } else {
        setshowModal(true);
      }
    }
  };

  const [anyfieldEdited, setanyfieldEdited] = useState(false);
  const [AllEditedIdsDict, setAllEditedIdsDict] = useState({});
  const checkReasonSelected = (id) => {
    AllEditedIdsDict[id] = false;
   
  };
  const handleID1 = (params, rowId, event) => {
    
    if (event.target.value != "") {
      checkReasonSelected(params.id);
    }
    var m1_plus_minus = event.target.value;
    
   
    params.row.m1_plus_minus = m1_plus_minus;
    setadjustedId(params.id);
    const enteredValue = event.target.value;
    setEnteredValue(event.target.value);
    setadjustedBrand(params.row.brand);
    addedList[params.row.brand][params.row.id] = parseFloat(
      unadjustedList[params.row.brand][params.row.id]
    );
   
    // if(rows.id==params.id){
    // setrows(rows.id.m1_plus_minus=m1_plus_minus)
    // }
    if (enteredValue == "") {
      addedList[params.row.brand][params.row.id] = parseFloat(
        unadjustedList[params.row.brand][params.row.id]
      );
    } else {
      addedList[params.row.brand][params.row.id] =
        parseFloat(unadjustedList[params.row.brand][params.row.id]) +
        parseFloat(event.target.value);
    
    }
    
    let sum = 0;
    for (let i in addedList[params.row.brand]) {
      sum = sum + parseFloat(addedList[params.row.brand][i]);
    }
    adjustedtotalBrandSum[params.row.brand] = sum;
  
    let totalAdjustedUnitSum = 0;

    Object.entries(adjustedtotalBrandSum).forEach(([key, value]) => {
      totalAdjustedUnitSum = totalAdjustedUnitSum + adjustedtotalBrandSum[key];
    });

    // console.log(params.row.dynamic_field.slice(0, -1), "DYNAMIC_RCI");
    if (enteredValue != "") {
      const temp_rci =
        (parseFloat(unadjustedList[params.row.brand][params.row.id]) +
          parseFloat(event.target.value)) /
        totalAdjustedUnitSum;

      setcalculatedRci((temp_rci * 100).toFixed(2));

     
    } else {
      const temp_rci =
        parseFloat(unadjustedList[params.row.brand][params.row.id]) /
        totalAdjustedUnitSum;

      setcalculatedRci((temp_rci * 100).toFixed(2));
    }
    setshowErrorMsg(true);
  };

  const handleComment = (params, rowId, event) => {
    var comment = event.target.value;
    params.row.comment = comment;
  };
  // logic for increase/decrease_2

  const [unadjustedList1, setunadjustedList1] = useState({});
  const [addedList1, setaddedList1] = useState({});
  const [showErrorMsg1, setshowErrorMsg1] = useState(false);
  const [adjustedBrand1, setadjustedBrand1] = useState("");
  const [adjustedId1, setadjustedId1] = useState(0);
  const [errorMessage1, seterrorMessage1] = useState("");
  const [EnteredValue1, setEnteredValue1] = useState(0);
  const [brandWiseSum1, setbrandWiseSum1] = useState(0);
  const [totalBrandSum1, settotalBrandSum1] = useState({});
  const [adjustedtotalBrandSum1, setadjustedTotalBrandSum1] =
    useState(totalBrandSum1);
  const [keysList1, setkeysList1] = useState([]);
  const [calculatedRci1, setcalculatedRci1] = useState("");
  const [comments1, setcomments1] = useState("");
  const [commentsColor1, setcommentsColor1] = useState("");



  const handleID2 = (params, rowId, event) => {
    if (event.target.value != "") {
      checkReasonSelected(params.id);
    }
    setadjustedId1(params.id);
    const enteredValue1 = event.target.value;
    setEnteredValue1(event.target.value);
    setadjustedBrand1(params.row.brand);
    addedList2[params.row.brand][params.row.id] = parseFloat(
      unadjustedList2[params.row.brand][params.row.id]
    );

    if (enteredValue1 == "") {
      addedList1[params.row.brand][params.row.id] = parseFloat(
        unadjustedList1[params.row.brand][params.row.id]
      );
    } else {
      addedList1[params.row.brand][params.row.id] =
        parseFloat(unadjustedList1[params.row.brand][params.row.id]) +
        parseFloat(event.target.value);
    }
   

    let sum1 = 0;
    for (let i in addedList1[params.row.brand]) {
      sum1 = sum1 + parseFloat(addedList1[params.row.brand][i]);
    }
    adjustedtotalBrandSum1[params.row.brand] = sum1;
  

    let totalAdjustedUnitSum1 = 0;

    Object.entries(adjustedtotalBrandSum1).forEach(([key, value]) => {
      totalAdjustedUnitSum1 =
        totalAdjustedUnitSum1 + adjustedtotalBrandSum1[key];
    });

    if (enteredValue1 != "") {
      const temp_rci1 =
        (parseFloat(unadjustedList1[params.row.brand][params.row.id]) +
          parseFloat(event.target.value)) /
        totalAdjustedUnitSum1;

      setcalculatedRci1((temp_rci1 * 100).toFixed(2));

    
    } else {
      const temp_rci1 =
        parseFloat(unadjustedList1[params.row.brand][params.row.id]) /
        totalAdjustedUnitSum1;

      setcalculatedRci1((temp_rci1 * 100).toFixed(2));
    }

    setshowErrorMsg1(true);
  };

  // logic for increase/decrease_3
  const [unadjustedList2, setunadjustedList2] = useState({});
  const [addedList2, setaddedList2] = useState({});
  const [showErrorMsg2, setshowErrorMsg2] = useState(false);
  const [adjustedBrand2, setadjustedBrand2] = useState("");
  const [adjustedId2, setadjustedId2] = useState(0);
  const [errorMessage2, seterrorMessage2] = useState("");
  const [EnteredValue2, setEnteredValue2] = useState(0);
  const [brandWiseSum2, setbrandWiseSum2] = useState(0);
  const [totalBrandSum2, settotalBrandSum2] = useState({});
  const [adjustedtotalBrandSum2, setadjustedTotalBrandSum2] =
    useState(totalBrandSum2);
  const [keysList2, setkeysList2] = useState([]);
  const [calculatedRci2, setcalculatedRci2] = useState("");
  const [comments2, setcomments2] = useState("");
  const [commentsColor2, setcommentsColor2] = useState("");

  const handleID3 = (params, rowId, event) => {
    if (event.target.value != "") {
      checkReasonSelected(params.id);
    }
    setadjustedId2(params.id);
    const enteredValue2 = event.target.value;
    setEnteredValue2(event.target.value);
    setadjustedBrand2(params.row.brand);
    addedList2[params.row.brand][params.row.id] = parseFloat(
      unadjustedList2[params.row.brand][params.row.id]
    );
    if (enteredValue2 == "") {
      addedList2[params.row.brand][params.row.id] = parseFloat(
        unadjustedList2[params.row.brand][params.row.id]
      );
    } else {
      addedList2[params.row.brand][params.row.id] =
        parseFloat(unadjustedList2[params.row.brand][params.row.id]) +
        parseFloat(event.target.value);
    }
  

    let sum2 = 0;
    for (let i in addedList2[params.row.brand]) {
      sum2 = sum2 + parseFloat(addedList2[params.row.brand][i]);
    }

    adjustedtotalBrandSum2[params.row.brand] = sum2;

    let totalAdjustedUnitSum2 = 0;

    Object.entries(adjustedtotalBrandSum2).forEach(([key, value]) => {
      totalAdjustedUnitSum2 =
        totalAdjustedUnitSum2 + adjustedtotalBrandSum2[key];
    });

    if (enteredValue2 != "") {
      const temp_rci2 =
        (parseFloat(unadjustedList2[params.row.brand][params.row.id]) +
          parseFloat(event.target.value)) /
        totalAdjustedUnitSum2;

      setcalculatedRci2((temp_rci2 * 100).toFixed(2));

     
    } else {
      const temp_rci2 =
        parseFloat(unadjustedList2[params.row.brand][params.row.id]) /
        totalAdjustedUnitSum2;

      setcalculatedRci2((temp_rci2 * 100).toFixed(2));
    }

    setshowErrorMsg2(true);
  };

  // const formatFunc = (input) =>{
  //   var x=params.row.adjusted_budget_unit_1;
  //   x=x.toString();
  //   var afterPoint = '';
  //   if(x.indexOf('.') > 0)
  //      afterPoint = x.substring(x.indexOf('.'),x.length);
  //   x = Math.floor(x);
  //   x=x.toString();
  //   var lastThree = x.substring(x.length-3);
  //   var otherNumbers = x.substring(0,x.length-3);
  //   if(otherNumbers != '')
  //       lastThree = ',' + lastThree;
  //   var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
  // }
  const [selectedReason, setselectedReason] = useState("");
  const [ReasonSelected, setReasonSelected] = useState(true);
  const [loaderFilter, setLoaderFilter] = useState(false);

  const [editedDropdownId, seteditedDropdownId] = useState(false);
  const rcicolumn=localStorage.getItem('teamcode')=="T1"?"35 MTH % rci (Val)":"35 MTH % rci (UN)"

  const handleSelectReason = (params, event) => {
    seteditedDropdownId(params.id);
    AllEditedIdsDict[params.id] = true;
 
    params.row.reason = event.target.value;
    // console.log(event.target.value, "SELECTED REASON");
    // setselectedReason(event.target.value);
    // if (selectedReason != "") {
    //   setReasonSelected(true);
    // }
  };
 
  const   columns = [
    { field: "id", headerName: "ID", width: 40, hide: true },
    {
      field: "rbmname",
      headerName: "RBM Name",
      width: 130,
      renderCell: (params, rowId) => {
       
        return (
          <p title={params.row.rbmname} className="ellipsis">
            {params.row.rbmname}
          </p>
        );
      },
    },
    {
      field: "rbmcode",
      headerName: "RBM Code",
      width: 130,
      hide:true,
      renderCell: (params, rowId) => {
       
        return (
          <p title={params.row.rbmcode} className="ellipsis">
            {params.row.rbmcode}
          </p>
        );
      },
    },
    {
      field: "abmname",
      headerName: "ABM Name",
      width: 130,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.abmname} className="ellipsis">
            {params.row.abmname}
          </p>
        );
      },
    },
    {
      field: "abmcode",
      headerName: "ABM Code",
      width: 130,
      hide:true,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.abmcode} className="ellipsis">
            {params.row.abmcode}
          </p>
        );
      },
    },
    {
      field: "repname",
      headerName: "REPHQ Name",
      width: 130,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.repname} className="ellipsis">
            {params.row.repname}
          </p>
        );
      },
    },
    {
      field: "repcode",
      headerName: "REPHQ Code",
      width: 130,
      hide:true,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.repcode} className="ellipsis">
            {params.row.repcode}
          </p>
        );
      },
    },
    {
      field: "brand",
      headerName: "Brand",
      width: 80,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.brand} className="ellipsis">
            {params.row.brand}
          </p>
        );
      },
    },
    {
      field: "prodcode",
      headerName: "Product Code",
      width: 120,
      hide:true,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.prodcode} className="ellipsis">
            {params.row.prodcode}
          </p>
        );
      },
    },
    {
      field: "proddesc",
      headerName: "Product",
      width: 120,
      renderCell: (params, rowId) => {
        return (
          <p title={params.row.proddesc} className="ellipsis">
            {params.row.proddesc}
          </p>
        );
      },
    },
    // {
    //   field: "rci",
    //   headerName: rcicolumn,
    //   width: 100,
    // },
    // { field: "median", headerName: "Median", width: 60 },
    // { field: "maxx", headerName: "Max", width: 60 },
    // {
    //   field: "m1_unadjusted_budget_unit",
    //   headerName: `Unadj.Budget UN(${Month1})`,
    //   width: 100,
    // },
    // {
    //   field: "m1_unadjusted_budget_value",
    //   headerName: `Unadj.Budget Val(${Month1})`,
    //   width: 100,
    // },
    // {
    //   field: "m1_plus_minus",
    //   headerName: "Inc/Dec",
    //   width: 130,
    //   renderCell: (params, rowId) => {
    //     if (
    //       params.row.brand === adjustedBrand &&
    //       params.row.id === adjustedId &&
    //       EnteredValue !== ""
    //     ) {
    //       if (
    //         parseInt(adjustedtotalBrandSum[adjustedBrand]) >
    //           parseInt(totalBrandSum[adjustedBrand]) &&
    //         EnteredValue != "0"
    //       ) {
    //         params.row.m1_plus_minus = EnteredValue;
    //         seterrorMessage("BEYOND RBM BUDGET");
          
    //       } else if (
    //         parseInt(adjustedtotalBrandSum[adjustedBrand]) <
    //           parseInt(totalBrandSum[adjustedBrand]) &&
    //         EnteredValue != "0"
    //       ) {
    //         params.row.m1_plus_minus = EnteredValue;
    //         seterrorMessage("BELOW RBM BUDGET");
          
    //       } else if (
    //         parseInt(adjustedtotalBrandSum[adjustedBrand]) ==
    //           parseInt(totalBrandSum[adjustedBrand]) ||
    //         EnteredValue == ""
    //       ) {
    //         params.row.m1_plus_minus = EnteredValue;
    //         // addedList[params.row.brand][params.row.id] = parseFloat(
    //         //   unadjustedList[params.row.brand][params.row.id]

    //         // );
    //         seterrorMessage("");
          
    //       }
    //     }
    //     return (
    //       <div>
    //         <input
    //           id="EnteredTxt"
    //           type="number"
    //           onChange={(event) => handleID1(params, rowId, event)}
    //           style={{ width: "100px", fontWeight: "bold" }}
    //           defaultValue={parseInt(params.row.m1_plus_minus)}
    //           disabled={disabled}
    //         />

    //         {params.row.brand === adjustedBrand ? (
    //           <p
    //             style={{
    //               fontSize: "8px",
    //               paddingLeft: "5px",
    //               margin: "0px",
    //               color: "red",
    //             }}
    //           >
    //             {errorMessage}
    //           </p>
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    // },

    {
      field: "m1_adjusted_budget_unit",
      headerName: `Bud U(${Month1})`,
      width: 100,
      align:"center",
      renderCell: (params) => {
        if (
          params.row.brand === adjustedBrand &&
          params.row.id === adjustedId
        ) {
          for (let row of rows) {
            if (row["id"] === adjustedId) {
              row["m1_adjusted_budget_unit"] =
                addedList[adjustedBrand][adjustedId];
            }
          }
        }
      },
    },
    {
      field: "m1_adjusted_budget_value",
      headerName: `Bud V(${Month1})`,
      width: 100,
      align:"center",
      renderCell: (params) => {
        if (
          params.row.brand === adjustedBrand &&
          params.row.id === adjustedId
        ) {
          for (let row of rows) {
            if (row["id"] === adjustedId) {
              params.row["m1_adjusted_budget_value"] = (
                (addedList[adjustedBrand][adjustedId] * params.row.nsp1) /
                100000
              ).toFixed(2);
            }
          }
        }
      },
    },
    // {
    //   field: "post_budget_adjustment_m1_rci",
    //   headerName: `Adj RCI UN(${Month1})`,
    //   width: 100,
    //   renderCell: (params) => {
    //     if (params.row.id === adjustedId) {
    //       params.row.post_budget_adjustment_m1_rci = calculatedRci;
    //     }
    //   },
    // },
    // {
    //   field: "m2_unadjusted_budget_unit",
    //   headerName: `Unadj.Budget UN(${Month2})`,
    //   width: 100,
    // },
    // {
    //   field: "m2_unadjusted_budget_value",
    //   headerName: `Unadj.Budget VAL(${Month2})`,
    //   width: 100,
    // },
    // {
    //   field: "m2_plus_minus",
    //   headerName: "Inc/Dec",
    //   width: 130,
    //   renderCell: (params, rowId) => {
    //     if (
    //       params.row.brand === adjustedBrand1 &&
    //       params.id === adjustedId1 &&
    //       EnteredValue1 !== ""
    //     ) {
    //       if (
    //         parseInt(adjustedtotalBrandSum1[adjustedBrand1]) >
    //           parseInt(totalBrandSum1[adjustedBrand1]) &&
    //         EnteredValue1 != "0"
    //       ) {
    //         params.row.m2_plus_minus = EnteredValue1;
    //         seterrorMessage1("BEYOND RBM BUDGET");
    //       } else if (
    //         parseInt(adjustedtotalBrandSum1[adjustedBrand1]) <
    //           parseInt(totalBrandSum1[adjustedBrand1]) &&
    //         EnteredValue1 != "0"
    //       ) {
    //         params.row.m2_plus_minus = EnteredValue1;
    //         seterrorMessage1("BELOW RBM BUDGET");
    //       } else if (
    //         parseInt(adjustedtotalBrandSum1[adjustedBrand1]) ==
    //           parseInt(totalBrandSum1[adjustedBrand1]) ||
    //         EnteredValue1 == ""
    //       ) {
    //         params.row.m2_plus_minus = EnteredValue1;

    //         seterrorMessage1("");
    //       }
    //     }
    //     return (
    //       <div>
    //         <input
    //           id="EnteredTxt1"
    //           type="number"
    //           onChange={(event) => handleID2(params, rowId, event)}
    //           style={{ width: "100px", fontWeight: "bold" }}
    //           defaultValue={parseInt(params.row.m2_plus_minus)}
    //           disabled={disabled}
    //         />

    //         {params.row.brand === adjustedBrand1 ? (
    //           <p
    //             style={{
    //               fontSize: "8px",
    //               paddingLeft: "5px",
    //               margin: "0px",
    //               color: "red",
    //             }}
    //           >
    //             {errorMessage1}
    //           </p>
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      field: "m2_adjusted_budget_unit",
      headerName: `Bud U(${Month2})`,
      width: 100,
      align:"center",
      renderCell: (params) => {
        if (
          params.row.brand === adjustedBrand1 &&
          params.row.id === adjustedId1
        ) {
          for (let row of rows) {
            if (row["id"] === adjustedId1) {
              row["m2_adjusted_budget_unit"] =
                addedList1[adjustedBrand1][adjustedId1];
            }
          }
        }
      },
    },
    {
      field: "m2_adjusted_budget_value",
      headerName: `Bud V(${Month2})`,
      width: 100,
      align:"center",
      renderCell: (params) => {
        if (
          params.row.brand === adjustedBrand1 &&
          params.row.id === adjustedId1
        ) {
          for (let row of rows) {
            if (row["id"] === adjustedId1) {
              params.row["m2_adjusted_budget_value"] = (
                (addedList1[adjustedBrand1][adjustedId1] * params.row.nsp2) /
                100000
              ).toFixed(2);
            }
          }
        }
      },
    },
    // {
    //   field: "post_budget_adjustment_m2_rci",
    //   headerName: `Adj RCI UN(${Month2})`,
    //   width: 100,
    //   renderCell: (params) => {
    //     if (params.row.id === adjustedId1) {
    //       params.row.post_budget_adjustment_m2_rci = calculatedRci1;
    //     }
    //   },
    // },
    // {
    //   field: "m3_unadjusted_budget_unit",
    //   headerName: `Unadj.Budget UN(${Month3})`,
    //   width: 100,
    // },
    // {
    //   field: "m3_unadjusted_budget_value",
    //   headerName: `Unadj.Budget Val(${Month3})`,
    //   width: 100,
    // },
    // {
    //   field: "m3_plus_minus",
    //   headerName: "Inc/Dec",
    //   width: 130,
    //   renderCell: (params, rowId) => {
    //     if (
    //       params.row.brand === adjustedBrand2 &&
    //       params.id === adjustedId2 &&
    //       EnteredValue2 !== ""
    //     ) {
    //       if (
    //         parseInt(adjustedtotalBrandSum2[adjustedBrand2]) >
    //           parseInt(totalBrandSum2[adjustedBrand2]) &&
    //         EnteredValue2 != "0"
    //       ) {
    //         params.row.m3_plus_minus = EnteredValue2;
    //         seterrorMessage2("BEYOND RBM BUDGET");
    //       } else if (
    //         parseInt(adjustedtotalBrandSum2[adjustedBrand2]) <
    //           parseInt(totalBrandSum2[adjustedBrand2]) &&
    //         EnteredValue2 != "0"
    //       ) {
    //         params.row.m3_plus_minus = EnteredValue2;
    //         seterrorMessage2("BELOW RBM BUDGET");
    //       } else if (
    //         parseInt(adjustedtotalBrandSum2[adjustedBrand2]) ==
    //           parseInt(totalBrandSum2[adjustedBrand2]) ||
    //         EnteredValue2 == ""
    //       ) {
    //         params.row.m3_plus_minus = EnteredValue2;

    //         seterrorMessage2("");
          
    //       }
    //     }
    //     return (
    //       <div>
    //         <input
    //           id="EnteredTxt2"
    //           type="number"
    //           onChange={(event) => handleID3(params, rowId, event)}
    //           style={{ width: "100px", fontWeight: "bold" }}
    //           defaultValue={parseInt(params.row.m3_plus_minus)}
    //           disabled={disabled}
    //         />

    //         {params.row.brand === adjustedBrand2 ? (
    //           <p
    //             style={{
    //               fontSize: "8px",
    //               paddingLeft: "5px",
    //               margin: "0px",
    //               color: "red",
    //             }}
    //           >
    //             {errorMessage2}
    //           </p>
    //         ) : (
    //           ""
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      field: "m3_adjusted_budget_unit",
      headerName: `Bud U(${Month3})`,
      width: 100,
      align:"center",
      renderCell: (params) => {
        if (
          params.row.brand === adjustedBrand2 &&
          params.row.id === adjustedId2
        ) {
          for (let row of rows) {
            if (row["id"] === adjustedId2) {
              row["m3_adjusted_budget_unit"] =
                addedList2[adjustedBrand2][adjustedId2];
            }
          }
        }
      },
    },
    {
      field: "m3_adjusted_budget_value",
      headerName: `Bud V(${Month3})`,
      width: 100,
      align:"center",
      renderCell: (params) => {
        if (
          params.row.brand === adjustedBrand2 &&
          params.row.id === adjustedId2
        )
          for (let row of rows) {
            if (row["id"] === adjustedId2) {
              params.row["m3_adjusted_budget_value"] = (
                (addedList2[adjustedBrand2][adjustedId2] * params.row.nsp3) /
                100000
              ).toFixed(2);
            }
          }
      },
    },
    // {
    //   field: "post_budget_adjustment_m3_rci",
    //   headerName: `Adj RCI UN(${Month3})`,
    //   width: 100,
    //   renderCell: (params) => {
    //     if (params.row.id === adjustedId2) {
    //       params.row.post_budget_adjustment_m3_rci = calculatedRci2;
    //     }
    //   },
    // },
    // {
    //   field: "rci_guardrail_check_m1",
    //   headerName: `Response(${Month1})`,
    //   width: 120,
    //   renderCell: (params) => {
    //     var tempComments = "";
    //     if (params.row.id == adjustedId) {
    //       if (
    //         between(
    //           parseFloat(params.row.post_budget_adjustment_m1_rci),
    //           parseFloat(params.row.median),
    //           parseFloat(params.row.maxx)
    //         )  || between(
    //           parseFloat(params.row.post_budget_adjustment_m1_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.median)
    //         ) || between(
    //           parseFloat(params.row.post_budget_adjustment_m1_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.maxx)
    //         )
    //         || parseFloat(params.row.post_budget_adjustment_m1_rci)==parseFloat(params.row.rci) 
    //         || parseFloat(params.row.post_budget_adjustment_m1_rci)==parseFloat(params.row.median) 
    //         || parseFloat(params.row.post_budget_adjustment_m1_rci)==parseFloat(params.row.maxx) 
    //       ) {
    //         tempComments = "within guardrail";
    //         setcomments("within guardrail");
    //         setcommentsColor("green");
    //         // params.row.rci_guardrail_check_m1 = "within guardrail"
           
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m1_rci) <
    //         parseFloat(params.row.rci)
    //       ) {
    //         setcomments("below guardrail");
    //         tempComments = "below guardrail";
    //         setcommentsColor("red");
    //         // params.row.rci_guardrail_check_m1 = "below guardrail"
           
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m1_rci) >
    //         parseFloat(params.row.maxx)
    //       ) {
    //         setcomments("beyond guardrail");
    //         tempComments = "beyond guardrail";
    //         setcommentsColor("red");
    //         // params.row.rci_guardrail_check_m1 = "beyond guardrail"
           
    //       } else {
    //         setcomments("");
    //         tempComments = "";
    //       }
    //     } else {
    //       if (
    //         between(
    //           parseFloat(params.row.post_budget_adjustment_m1_rci),
    //           parseFloat(params.row.median),
    //           parseFloat(params.row.maxx)
    //         )  || between(
    //           parseFloat(params.row.post_budget_adjustment_m1_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.median)
    //         ) || between(
    //           parseFloat(params.row.post_budget_adjustment_m1_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.maxx)
    //         )
    //         || parseFloat(params.row.post_budget_adjustment_m1_rci)==parseFloat(params.row.rci) 
    //         || parseFloat(params.row.post_budget_adjustment_m1_rci)==parseFloat(params.row.median) 
    //         || parseFloat(params.row.post_budget_adjustment_m1_rci)==parseFloat(params.row.maxx) 
    //       ) {
    //         setcomments("within guardrail");
    //         setcommentsColor("green");
    //         params.row.rci_guardrail_check_m1 = "within guardrail";
          
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m1_rci) <
    //         parseFloat(params.row.rci)
    //       ) {
    //         setcomments("below guardrail");
    //         setcommentsColor("red");
    //         params.row.rci_guardrail_check_m1 = "below guardrail";
    //         // console.log(
    //         //   params.row.maxx,
    //         //   params.row.median,
    //         //   params.row.post_budget_adjustment_m1_rci,
    //         //   "++++++++++++++ELSE IF"
    //         // );
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m1_rci) >
    //         parseFloat(params.row.maxx)
    //       ) {
    //         setcomments("beyond guardrail");
    //         setcommentsColor("red");
    //         params.row.rci_guardrail_check_m1 = "beyond guardrail";
           
    //       } else {
    //         setcomments("");
    //       }
    //     }
    //     return (
    //       <div>
    //         {" "}
    //         {params.row.id == adjustedId ? (
    //           <p
    //             style={{
    //               color: tempComments == "within guardrail" ? "green" : "red",
    //             }}
    //           >
    //             {tempComments}
    //           </p>
    //         ) : (
    //           <p
    //             style={{
    //               color:
    //                 params.row.rci_guardrail_check_m1 == "within guardrail"
    //                   ? "green"
    //                   : "red",
    //             }}
    //           >
    //             {params.row.rci_guardrail_check_m1}
    //           </p>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "rci_guardrail_check_m2",
    //   headerName: `Response(${Month2})`,
    //   width: 120,
    //   renderCell: (params) => {
    //     var tempComments1 = "";
    //     if (params.row.id == adjustedId1) {
    //       if (
    //         between(
    //           parseFloat(params.row.post_budget_adjustment_m2_rci),
    //           parseFloat(params.row.median),
    //           parseFloat(params.row.maxx)
    //         )  || between(
    //           parseFloat(params.row.post_budget_adjustment_m2_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.median)
    //         ) || between(
    //           parseFloat(params.row.post_budget_adjustment_m2_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.maxx)
    //         )
    //         || parseFloat(params.row.post_budget_adjustment_m2_rci)==parseFloat(params.row.rci) 
    //         || parseFloat(params.row.post_budget_adjustment_m2_rci)==parseFloat(params.row.median) 
    //         || parseFloat(params.row.post_budget_adjustment_m2_rci)==parseFloat(params.row.maxx) 
    //       ) {
    //         tempComments1 = "within guardrail";
    //         setcomments1("within guardrail");
    //         setcommentsColor1("green");
    //         // params.row.rci_guardrail_check_m1 = "within guardrail"
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m2_rci) <
    //         parseFloat(params.row.rci)
    //       ) {
    //         setcomments1("below guardrail");
    //         tempComments1 = "below guardrail";
    //         setcommentsColor1("red");
    //         // params.row.rci_guardrail_check_m1 = "below guardrail"
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m2_rci,"++++++++++++++ELSE IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m2_rci) >
    //         parseFloat(params.row.maxx)
    //       ) {
    //         setcomments1("beyond guardrail");
    //         tempComments1 = "beyond guardrail";
    //         setcommentsColor1("red");
    //         // params.row.rci_guardrail_check_m1 = "beyond guardrail"
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
    //       } else {
    //         setcomments1("");
    //         tempComments1 = "";
    //       }
    //     } else {
    //       if (
    //         between(
    //           parseFloat(params.row.post_budget_adjustment_m2_rci),
    //           parseFloat(params.row.median),
    //           parseFloat(params.row.maxx)
    //         )  || between(
    //           parseFloat(params.row.post_budget_adjustment_m2_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.median)
    //         ) || between(
    //           parseFloat(params.row.post_budget_adjustment_m2_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.maxx)
    //         )
    //         || parseFloat(params.row.post_budget_adjustment_m2_rci)==parseFloat(params.row.rci) 
    //         || parseFloat(params.row.post_budget_adjustment_m2_rci)==parseFloat(params.row.median) 
    //         || parseFloat(params.row.post_budget_adjustment_m2_rci)==parseFloat(params.row.maxx)
    //       ) {
    //         setcomments1("within guardrail");
    //         setcommentsColor1("green");
    //         params.row.rci_guardrail_check_m2 = "within guardrail";
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m2_rci) <
    //         parseFloat(params.row.rci)
    //       ) {
    //         setcomments1("below guardrail");
    //         setcommentsColor1("red");
    //         params.row.rci_guardrail_check_m2 = "below guardrail";
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++ELSE IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m2_rci) >
    //         parseFloat(params.row.maxx)
    //       ) {
    //         setcomments1("beyond guardrail");
    //         setcommentsColor1("red");
    //         params.row.rci_guardrail_check_m2 = "beyond guardrail";
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
    //       } else {
    //         setcomments1("");
    //       }
    //     }
    //     return (
    //       <div>
    //         {" "}
    //         {params.row.id == adjustedId1 ? (
    //           <p
    //             style={{
    //               color: tempComments1 == "within guardrail" ? "green" : "red",
    //             }}
    //           >
    //             {tempComments1}
    //           </p>
    //         ) : (
    //           <p
    //             style={{
    //               color:
    //                 params.row.rci_guardrail_check_m2 == "within guardrail"
    //                   ? "green"
    //                   : "red",
    //             }}
    //           >
    //             {params.row.rci_guardrail_check_m2}
    //           </p>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "rci_guardrail_check_m3",
    //   headerName: `Response(${Month3})`,
    //   width: 150,
    //   renderCell: (params) => {
    //     var tempComments2 = "";
    //     if (params.row.id == adjustedId2) {
    //       if (
    //         between(
    //           parseFloat(params.row.post_budget_adjustment_m3_rci),
    //           parseFloat(params.row.median),
    //           parseFloat(params.row.maxx)
    //         )  || between(
    //           parseFloat(params.row.post_budget_adjustment_m3_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.median)
    //         ) || between(
    //           parseFloat(params.row.post_budget_adjustment_m3_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.maxx)
    //         )
    //         || parseFloat(params.row.post_budget_adjustment_m3_rci)==parseFloat(params.row.rci) 
    //         || parseFloat(params.row.post_budget_adjustment_m3_rci)==parseFloat(params.row.median) 
    //         || parseFloat(params.row.post_budget_adjustment_m3_rci)==parseFloat(params.row.maxx)
    //       ) {
    //         tempComments2 = "within guardrail";
    //         setcomments2("within guardrail");
    //         setcommentsColor2("green");
    //         // params.row.rci_guardrail_check_m3 = "within guardrail"
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m3_rci,"++++++++++++++IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m3_rci) <
    //         parseFloat(params.row.rci)
    //       ) {
    //         setcomments2("below guardrail");
    //         tempComments2 = "below guardrail";
    //         setcommentsColor2("red");
    //         // params.row.rci_guardrail_check_m1 = "below guardrail"
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m3_rci,"++++++++++++++ELSE IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m3_rci) >
    //         parseFloat(params.row.maxx)
    //       ) {
    //         setcomments2("beyond guardrail");
    //         tempComments2 = "beyond guardrail";
    //         setcommentsColor2("red");
    //         // params.row.rci_guardrail_check_m1 = "beyond guardrail"
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
    //       } else {
    //         setcomments2("");
    //         tempComments2 = "";
    //       }
    //     } else {
    //       if (
    //         between(
    //           parseFloat(params.row.post_budget_adjustment_m3_rci),
    //           parseFloat(params.row.median),
    //           parseFloat(params.row.maxx)
    //         )  || between(
    //           parseFloat(params.row.post_budget_adjustment_m3_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.median)
    //         ) || between(
    //           parseFloat(params.row.post_budget_adjustment_m3_rci),
    //           parseFloat(params.row.rci),
    //           parseFloat(params.row.maxx)
    //         )
    //         || parseFloat(params.row.post_budget_adjustment_m3_rci)==parseFloat(params.row.rci) 
    //         || parseFloat(params.row.post_budget_adjustment_m3_rci)==parseFloat(params.row.median) 
    //         || parseFloat(params.row.post_budget_adjustment_m3_rci)==parseFloat(params.row.maxx)
    //       ) {
    //         setcomments2("within guardrail");
    //         setcommentsColor2("green");
    //         params.row.rci_guardrail_check_m3 = "within guardrail";
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m3_rci) <
    //         parseFloat(params.row.rci)
    //       ) {
    //         setcomments2("below guardrail");
    //         setcommentsColor2("red");
    //         params.row.rci_guardrail_check_m3 = "below guardrail";
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++ELSE IF")
    //       } else if (
    //         parseFloat(params.row.post_budget_adjustment_m3_rci) >
    //         parseFloat(params.row.maxx)
    //       ) {
    //         setcomments2("beyond guardrail");
    //         setcommentsColor2("red");
    //         params.row.rci_guardrail_check_m3 = "beyond guardrail";
    //         // console.log(params.row.maxx,params.row.median,params.row.post_budget_adjustment_m1_rci,"++++++++++++++ ELSE IF2")
    //       } else {
    //         setcomments2("");
    //       }
    //     }
    //     return (
    //       <div>
    //         {" "}
    //         {params.row.id == adjustedId2 ? (
    //           <p
    //             style={{
    //               color: tempComments2 == "within guardrail" ? "green" : "red",
    //             }}
    //           >
    //             {tempComments2}
    //           </p>
    //         ) : (
    //           <p
    //             style={{
    //               color:
    //                 params.row.rci_guardrail_check_m3 == "within guardrail"
    //                   ? "green"
    //                   : "red",
    //             }}
    //           >
    //             {params.row.rci_guardrail_check_m3}
    //           </p>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "reason",
    //   headerName: "Reason*",
    //   width: 150,
    //   renderCell: (params) => {
    //     return (
    //       <select
    //         key={params.id}
    //         className="filter-style1"
    //         id="rbm"
    //         style={{ marginRight: "5px", width: "200px" }}
    //         onChange={(event) => handleSelectReason(params, event)}
    //         value={params.row.reason}
    //       >
    //         <option>Select Reason*</option>
    //         {resonsComponent}
    //       </select>
    //     );
    //   },
    // },
    // {
    //   field: "comment",
    //   headerName: "Add Comments",
    //   width: 150,
    //   renderCell: (params) => {
    //     return (
    //       <textarea
    //         name=""
    //         id=""
    //         cols="30"
    //         rows="2"
    //         style={{
    //           border: "none",
    //           backgroundColor: "#E5E5E5",
    //           borderRadius: "5px",
    //         }}
    //         onchange={handleComment}
    //       >
    //         {/* {params.row.comment} */}
    //       </textarea>
    //     );
    //   },
    // },
  ];
  let BransListComponent = [];
  BrandsListData.forEach((item, index) => {
    BransListComponent.push(<option key={index}>{item}</option>);
  });

  const handleChangeBrand = (event) => {
    for (let item of filtersData) {
      setselectedBrand(event.target.value);
      let flag = true;
      if (item["brandname"] == event.target.value) {
       
        if(event.target.value == "All"){
          setproductsListData(item["productname"]);
        }else{
        setproductsListData(["All",...item["productname"]]);
        }
        if (flag) {
          setselectedProduct("All");
          flag = false;
        }
      }
    }
  
    //  setproductsListData(filtersData[event.target.value])
  };

  let productComponent = [];
  productsListData.forEach((item, index) => {
    productComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
  // const handleChangeProduct = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setselectedProduct(typeof value === "string" ? value.split(",") : value);
  // };

  // const handleChangeMultiple = (event) => {
  //   const { options } = event.target;
  //   const value = [];
  //   for (let i = 0, l = options.length; i < l; i += 1) {
  //     if (options[i].selected) {
  //       value.push(options[i].value);
  //     }
  //   }
  //   setselectedProduct(value);
  // };
  const handleChangeProduct = (event) => {
    const temp = event.target.value;
    setselectedProduct(temp);
   
  };
 

  const handleDownload = (event) => {
    axiosRequest({
      url: "bu_head_app/downloadfilterdata",
      method: "GET",
    }).then(function (response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      // let temp_file_name = table + ".csv";
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Buhead Data.csv");
      document.body.appendChild(link);
      link.click();
      // handleSnackBar("downloaded successfully","success");
    });
  };
  const [reasonsList, setreasonsList] = useState([]);
  //APi to get Reasons dropdown  data
  const getReasonsdata = async () => {
    await axiosRequest({
      url: "bu_head_app/getreasons/",
      method: "GET",
    }).then((data) => {
      if (data.status === 200) {
      
        setreasonsList(data?.data?.data);
      } else {
      }
    });
  };
  let resonsComponent = [];
  reasonsList.forEach((item, index) => {
    resonsComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });

  const [disabled, setdisabled] = useState(false);

  return (
    <div style={{ height: 400, width: "100%" }} className="rbm-table">
      <div style={{}}>
        <Modal
          open={showModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <CloseIcon
              onClick={handleCloseModal}
              style={{
                marginLeft: "370px",
                color: "grey",
                alignSelf: "flex-end",
              }}
            />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Please save all the Brand and Product adjustments before
              submitting
            </Typography>
            <div
              style={{
                marginTop: "10px",
                marginLeft: "290px",
                alignSelf: "flex-end",
              }}
            >
              <button className="save-btn " onClick={handleSave}>
                {loaderSave === true ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress
                      size="1rem"
                      color="inherit"
                      display={loaderSave}
                    />
                  </div>
                ) : (
                  <span>Save as Draft</span>
                )}
              </button>
              <button
                onClick={handleCloseModal}
                style={{ marginLeft: "10px" }}
                className="submit-btn"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
        <Modal
          open={showStatusModal}
          onClose={handleCloseStatusModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <CloseIcon
              onClick={handleCloseStatusModal}
              style={{
                marginLeft: "370px",
                color: "grey",
                alignSelf: "flex-end",
              }}
            />
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Before Submitting all the Brands and respected products data
              should be saved by BuHead
            </Typography>
            <div
              style={{
                marginTop: "10px",
                marginLeft: "290px",
                alignSelf: "flex-end",
              }}
            >
              {/* <button className="save-btn" onClick={handleSave}>
                {loaderSave === true ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress
                      size="1rem"
                      color="inherit"
                      display={loaderSave}
                    />
                  </div>
                ) : (
                  <span>Save as Draft</span>
                )}
              </button> */}
              <button
                onClick={handleCloseStatusModal}
                style={{ marginLeft: "10px" }}
                className="submit-btn"
              >
                Close
              </button>
            </div>
          </Box>
        </Modal>
      </div>
      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          fontWeight: "500",
        }}
      >
           <p>Period - {localStorage.getItem('quarter')}{"  "},  {localStorage.getItem('year')}</p>
      </div> */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
          {/* <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "5px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              RBM Name
            </label>
            
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
            >
              <option value="volvo">ALL</option>
            </select>
          </div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>

            <select
              className="filter-style1"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeBrand(event)}
            >
              {loaderFilter === true ? (
                <option value="">Loading...</option>
              ) : (
                <option value="">select brand name</option>
              )}
              {BransListComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Product
            </label>
            {/* <FormControl sx={{ m: 1, width: 300 }}>
              {" "}
              <InputLabel id="demo-multiple-name-label">Name</InputLabel>{" "}
              <Select
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                multiple
                value={selectedProduct}
                onChange={handleChangeMultiple}
                input={<OutlinedInput label="Name" />}
                // MenuProps={MenuProps}
              >
                {" "}style
                {productsListData.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                    // style={getStyles(name, personName, theme)}
                  >
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>{" "} */}
            <select
              className="filter-style"
              id="rbm"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={handleChangeProduct}
              value={selectedProduct}
            >
              <option value="volvo">select product</option>
              {productComponent}
            </select>
          </div>
          <button
            onClick={handleApply}
            className="submit-btn"
            style={{ marginTop: "20px" }}
          >
            Apply
          </button>
        </div>
        <div style={{ display: "flex" }}>
          {/* <button className="save-btn" disabled={disabled} onClick={handleSave}>
            {loaderSave === true ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  size="1rem"
                  color="inherit"
                  display={loaderSave}
                />
              </div>
            ) : (
              <span>Save as Draft</span>
            )}
          </button> */}

          {/* <button
            className="submit-btn"
            style={{ marginRight: "10px", marginLeft: "10px" }}
            onClick={handleSubmit}
          >
            {loaderSubmit === true ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  size="1rem"
                  color="inherit"
                  display={loaderSubmit}
                />
              </div>
            ) : (
              <span>Submit</span>
            )}
          </button> */}
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            // onClick={handleDownload}
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
          <CSVLink 
          data={rows}
          headers={colums_rbm}
          filename={"REPHQ Budget Data.csv"} style={{textDecoration:"none",color:"black"}}>
          Download
          </CSVLink>

          </button>
        </div>
      </div>
      {loader == true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
          }}
        >
          <CircularProgress color="inherit" display={loader} />
        </div>
      ) : rows.length ? (
        <div>
        <DataGrid
          rows={rows}
          density="compact"
          columns={columns}
          pageSize={15}
          rowsPerPageOptions={[15]}
          // columnVisibilityModel={{
          //   // Hide columns status and traderName, the other columns will remain visible
          //   abmcode: false,
          //   rci_guardrail_check_m1:false,
          //   rci_guardrail_check_m2:false,
          //   rci_guardrail_check_m3:false,
          //   repcode:false,
          //   rbmname:false,
          //   id:false
            
          // }}
        />
        {loader === false ?(<div
          style={{
           
           height:"135px",
           width:"100%",
           marginBottom:"10px"
           
          }}
        >
        <table className='table-buh'>
    <tr className="table-tr-td-buh">
    <th className="table-tr-td-buh"></th>
      <th className="table-tr-td-buh">Adj Bug U({Month1}) </th>
      <th className="table-tr-td-buh">Adj Bug V({Month1}) </th>
      <th className="table-tr-td-buh">Adj Bug U({Month2}) </th>
      <th className="table-tr-td-buh">Adj Bug V({Month2}) </th>
      <th className="table-tr-td-buh">Adj Bug U({Month3}) </th>
      <th className="table-tr-td-buh">Adj Bug V({Month3}) </th>
      
      
    </tr>
    <tr className="table-tr-td-buh">
      <td className="table-tr-td-buh">Total</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_u']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_v']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_u1']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_v1']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_u2']}</td>
      <td className="table-tr-td-buh">{filtersDataSum['adj_tot_v2']}</td>

    </tr>
  </table>
        </div>):""}
        </div>
      ) : (
        <p style={{ textAlign: "center", marginTop: "150px" }}>
          Please Select the above filters to see the Data...
        </p>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          marginBottom: "50px",
          marginTop: "20px",
        }}
      ></div>
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
      />
    </div>
  );
}
